import { documentsTabApprovals } from '@l2u/shared/threadPartition';
import type { AdminSubmission } from '@l2u/ui/lib/types.ts';

// The admin submissions payload overlays unsent review drafts onto `status`
// (tab placement reads that), but whether a document's thread is cut at its
// approvals follows what the vendor actually sees: the LIVE status. So an
// Approve click before Notify does not partition yet, and a drafted rejection
// of an approved document keeps the partition until it is sent.

/** The admin's partition key: documentsTabApprovals judged on the LIVE status (live_status, falling back to status when an older API omits it). */
export function adminDocumentsTabApprovals(
  question: { include_in_compliance_documents: boolean },
  submission:
    | Pick<AdminSubmission, 'status' | 'live_status' | 'reverify_requested_at' | 'approvals'>
    | undefined,
): string[] | null {
  if (!submission) return null;
  return documentsTabApprovals(question, {
    status: submission.live_status ?? submission.status,
    reverify_requested_at: submission.reverify_requested_at ?? null,
    approvals: submission.approvals ?? null,
  });
}
